export enum ICampaignMetricKey {
  CONVERSION_RATE = 'CONVERSION_RATE',
  ORDER = 'ORDER',
  REVENUE = 'REVENUE',
  AOV = 'AOV',
  RPV = 'RPV',
  CTR = 'CTR',
  BOUNCE_RATE = 'BOUNCE_RATE',
  AVG_TIME = 'AVG_TIME',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_CART_RATE = 'ADD_TO_CART_RATE',
  SESSION = 'SESSION',
  PAGE_VIEWED = 'PAGE_VIEWED',
  VISITOR = 'VISITOR',
  VISITOR_BY_TYPE = 'VISITOR_BY_TYPE',
  PATH_ANALYSIS = 'PATH_ANALYSIS',

  // Session
  SESSION_THAT_REACHED_CHECKOUT = 'SESSION_THAT_REACHED_CHECKOUT',
  SESSION_THAT_COMPLETED_CHECKOUT = 'SESSION_THAT_COMPLETED_CHECKOUT',
  SESSION_REACHED_CHECKOUT = 'SESSION_REACHED_CHECKOUT',
  SESSION_WITH_CART_ADDITION = 'SESSION_WITH_CART_ADDITION',
  SESSIONS_BY_TRAFFIC_SOURCE = 'SESSIONS_BY_TRAFFIC_SOURCE',
  SESSIONS_BY_DEVICE_TYPE = 'SESSIONS_BY_DEVICE_TYPE',
}
